/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_Delete_ConfirmInputs */

const vi_vehicle_delete_confirm = /** @type {(inputs: Vehicle_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xóa xe này?`)
};

/**

* @param {Vehicle_Delete_ConfirmInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const vehicle_delete_confirm = /** @type {((inputs?: Vehicle_Delete_ConfirmInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Delete_ConfirmInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_vehicle_delete_confirm(inputs)
});